import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { OfflineDocumentsTypes } from 'types';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

export const driveUserDocumentOptions = [
	{ value: OfflineDocumentsTypes.RESUME, label: 'Does not have Resume' },
	{ value: OfflineDocumentsTypes.LAPTOP, label: 'Does not have Laptop' },
	{ value: OfflineDocumentsTypes.AADHAR_CARD, label: 'Does not have Aadhar Card' },
	{ value: 'verified', label: 'Verified' },
];

const DriveUserDocumentFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const userDocument = JSON.parse(searchParams.get('userDocument') || '[]');

	const options = driveUserDocumentOptions;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!userDocument?.length}
					placeholder={'Documents'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: userDocument?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										const optionValue = option?.value?.toString();
										if (userDocument?.includes(optionValue)) {
											// Remove the option
											let newUserDocument = userDocument.filter((status: string) => status !== optionValue);
											if (optionValue !== 'verified' && optionValue !== 'unverified') {
												// Check if there are any other options that require 'unverified'
												const needsUnverified = newUserDocument.some(
													(status: string) => status !== 'verified' && status !== 'unverified',
												);
												if (!needsUnverified) {
													newUserDocument = newUserDocument.filter((status: string) => status !== 'unverified');
												}
											}
											searchParams.set('userDocument', JSON.stringify(newUserDocument));
										} else {
											// Add the option
											let newUserDocument = [...userDocument, optionValue];
											if (
												optionValue !== 'verified' &&
												optionValue !== 'unverified' &&
												!userDocument.includes('unverified')
											) {
												// Add 'unverified' only if it's not already present
												newUserDocument.push('unverified');
											}
											searchParams.set('userDocument', JSON.stringify(newUserDocument));
										}
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{userDocument?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Documents</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Aadhar Card"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => userDocument?.includes(option?.value?.toString()))}
						onChange={option => {
							let newUserDocument = option?.map((option: any) => option?.value?.toString()) || [];

							// Add 'unverified' if any option other than 'verified' is selected and 'unverified' isn't already present
							if (
								newUserDocument.some(value => value !== 'verified' && value !== 'unverified') &&
								!newUserDocument.includes('unverified')
							) {
								newUserDocument.push('unverified');
							}

							// Remove 'unverified' if only 'verified' is selected
							if (newUserDocument.length === 1 && newUserDocument.includes('verified')) {
								newUserDocument = newUserDocument.filter(value => value !== 'unverified');
							}

							searchParams.set('userDocument', JSON.stringify(newUserDocument));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default DriveUserDocumentFilterInput;
